/**
 * @internal Backs `artis.v1.eod`: a state channel over the session's EOD dates with
 * catch-up for late subscribers. The worker bridge calls `set`; consumers subscribe
 * through the `v1.eod` surface, not this class.
 */
export class EodStore {
    snapshot;
    subs = new Set();
    set = (next) => {
        if (next.priorDate === this.snapshot?.priorDate && next.date === this.snapshot?.date)
            return;
        this.snapshot = next;
        for (const cb of this.subs)
            cb(next);
    };
    subscribe = (cb) => {
        this.subs.add(cb);
        if (this.snapshot)
            cb(this.snapshot);
        return () => void this.subs.delete(cb);
    };
}
//# sourceMappingURL=eodStore.js.map